import React, { FC } from "react";
import { Fade } from "react-awesome-reveal";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { StaticImage } from "gatsby-plugin-image";
import { LinkButton } from "@app/components/common";
import { LinkButtonType } from "@app/components/common/enums";
import { DEFAULT_FADE_DURATION } from "@app/constants";

export const SideImage: FC = () => {
  const { t } = useTranslation("p_investment_cost-calculator");

  return (
    <Fade duration={DEFAULT_FADE_DURATION} triggerOnce>
      <div className={classNames("flex justify-center")}>
        <div
          className={classNames(
            "flex flex-col items-center gap-5",
            "lg:w-full lg:flex-row lg:gap-15",
            "xl:max-w-container",
          )}
        >
          <div
            className={classNames(
              "lg:grow lg:basis-1/2 lg:text-center",
              "xxl:px-20",
            )}
          >
            <h2
              className={classNames(
                "mb-2.5 text-medium text-primary-content",
                "lg:mb-5 lg:text-large",
                "xl:text-xx-large",
              )}
            >
              {t("section_2_title")}
            </h2>
            <p
              className={classNames(
                "mb-2.5 text-regular text-base-400",
                "lg:mb-5",
              )}
            >
              {t("section_2_body")}
            </p>
            <LinkButton
              to={"/investment/managed-by-alpian/"}
              label={t("section_2_button")}
              type={LinkButtonType.LINK}
            />
          </div>
          <div
            className={classNames("w-full", "lg:w-auto lg:grow lg:basis-1/2")}
          >
            <StaticImage
              src={"./managed_by.webp"}
              alt="Managed by Alpian"
              className="rounded-lg"
            />
          </div>
        </div>
      </div>
    </Fade>
  );
};
